import { CorePaymentMethod } from "@oysterhr/schema"
import { Text, Alert } from "@oysterhr/ui"

import { isAuthorizable } from "../utils"
import { useHandleAuthorize } from "../actions"

interface WarningAuthorizeAlertProps {
  paymentMethod: CorePaymentMethod
}

export const WarningAuthorizeAlert = ({ paymentMethod }: WarningAuthorizeAlertProps) => {
  const { handleAuthorize } = useHandleAuthorize(paymentMethod)

  return paymentMethod && isAuthorizable(paymentMethod) ? (
    <Alert variation="warning">
      <Alert.Icon />
      <Alert.Content>
        <div className="flex">
          <Text>Payment method saved but not yet authorized.</Text>
          &nbsp;
          <button type="button" className="font-normal underline" onClick={handleAuthorize}>
            Authorize payment method
          </button>
        </div>
      </Alert.Content>
    </Alert>
  ) : null
}
